import React, { useState } from "react";
import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import { documents, infinityIcon, globeIcon, chatIcon, awardIcon, playIcon, closeIcon, externalLink } from "../../../constants/icons";

function AddToCartVerticalBlock({ className }) {
  const [modal, setModal] = useState(false);
  const [videoLoading, setVideoLoading] = useState(true);

  const openModal = () => {
    setModal(!modal);
  };

  const closeModal = () => {
    setModal(!modal);
  };

  const spinner = () => {
    setVideoLoading(!videoLoading);
  };
  return (
    <>
    <div className="addtocart-block-wrapper">
      <div className={`${className || ""} carousel-block p-0`}>
        <div className="img-carousel">
          <img src={SampleImage2} className="img-fluid" />
          <div onClick={openModal} className="btn-play">
            {playIcon}
          </div>
        </div>
        
        {/* <div className="course-image-wrapper">
          <img src={SampleImage2} className="img-fluid" alt="Course Image" />
          <div onClick={openModal} className="btn-play">
            {playIcon}
          </div>
        </div> */}
        <div className="desc-carousel">
          <div className="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
            <div className="pricing-slot pricing-left">
              <span>Current Price</span>
              <div className="price">₹199 <span>₹229</span></div>
              {/* <div className="price">Free</div> */}
            </div>
            <span className="separtor-price-set"></span>
            <div className="pricing-slot pricing-right">
              <span>Member Price</span>
              <div className="price">₹199 <span>₹229</span></div>
            </div>
          </div>
          <p className="exclusive-info">Inclusive of all taxes*</p>
          <div className="rating-cart-wrapper pt-0 border-0">
            <Button
              variant="outline"
              className="w-100 mb-3"
              size="md"
            >
              Add to cart
            </Button>
            <Button
              variant="secondary"
              className="w-100 mb-3"
              size="md"
            >
              Buy now
            </Button>
            <Button
              variant="outline"
              className="w-100 border-0 mb-0"
              size="md"
            >
              {chatIcon} Enquire Now
            </Button>
          </div>
          <div className="course-inclusion pt-3 mt-3">
            <h1>This course includes:</h1>
            <ul>
              <li className="d-flex align-items-center gap-1 mb-2">
                {documents}
                <span>14 Lectures</span>
              </li>
              <li className="d-flex align-items-center gap-1 mb-2">
                {infinityIcon}
                <span>Full lifetime access</span>
              </li>
              <li className="d-flex align-items-center gap-1 mb-2">
                {awardIcon}
                <span>Certified course</span>
              </li>
              <li className="d-flex align-items-center gap-1">
                {globeIcon}
                <span>English</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="addtocart-bottom-info">
        <h1>Get Subscription</h1>
        <p>Expert-led courses across a variety of online class topics for every step of your career. Instructors with real-world experience.</p>
        <Button
          variant="primary"
          className="w-100 mb-0"
          size="md"
        >
          Start my 1-month free trial
        </Button>
      </div>
    </div>
    {modal ? (
      <section className="modal__bg">
        <div className="modal__align">
          <div className="modal__content" modal={modal}>
            <div
              className="modal__close"
              arial-label="Close modal"
              onClick={closeModal}>
                {closeIcon} Close
            </div>
            <div className="modal__video-align">
              {videoLoading ? (
                <div className="modal__spinner">
                  <div
                    className="modal__spinner-style"
                    fadeIn="none">
                      {externalLink}
                  </div>
                </div>
              ) : null}
              <iframe
                className="modal__video-style"
                onLoad={spinner}
                loading="lazy"
                width="800"
                height="500"
                src="https://www.youtube.com/embed/4UZrsTqkcW4"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    ) : null}
    </>
  );
}

export default AddToCartVerticalBlock;
